/**
 * Forhåndsutfylt melding til kunden i bookingdialogen (CRM-4.4). Malen kommer fra
 * system_config.crm_meeting_email_templates.invite_body med plassholderne
 * {fornavn} og {vert}. Teksten skal aldri nevne transkripsjon (Meet varsler
 * deltakerne selv).
 */
export const DEFAULT_INVITE_BODY =
  "Hei {fornavn}\n\nVi gleder oss til å møte deg. Vi tar en prat om det vi snakket om.\n\nVennlig hilsen\n{vert}\nSølvrev Produksjoner";

export function parseInviteBody(value: unknown): string {
  const v = value && typeof value === "object" ? (value as Record<string, unknown>).invite_body : null;
  return typeof v === "string" && v.trim() ? v : DEFAULT_INVITE_BODY;
}

export function firstName(fullName: string | null | undefined): string {
  return (fullName ?? "").trim().split(/\s+/)[0] ?? "";
}

/** Fyller {fornavn} og {vert}; en manglende vert står som plassholder til verten er valgt. */
export function buildInviteMessage(template: string, vars: { contactName: string | null; hostName: string | null }): string {
  return template
    .replace(/\{fornavn\}/g, firstName(vars.contactName) || "der")
    .replace(/\{vert\}/g, vars.hostName ?? "{vert}");
}

export function defaultMeetingTitle(partyName: string, topic?: string | null): string {
  const t = topic?.trim();
  return t ? `Møte med ${partyName}: ${t}` : `Møte med ${partyName}`;
}

/** Sjekk som hindrer at meldingen sendes med en uløst plassholder eller et ord om transkripsjon. */
export function messageProblem(message: string): string | null {
  if (/\{\w+\}/.test(message)) return "Meldingen har en plassholder som ikke er fylt ut. Velg vert først.";
  if (/transkri/i.test(message)) return "Meldingen skal ikke nevne transkripsjon. Meet varsler deltakerne selv.";
  return null;
}
